import {postLoginRequest} from "../../../common/helpers/RequestHelper";

class HeaderService {
    apiVerifyDomain = `${process.env.REACT_APP_API_DOMAIN}/api/v1/domain/verify`;
    public fetchDomain(params:any): Promise<any> {
        return postLoginRequest(this.apiVerifyDomain,params);
    }
}

export const headerService = new HeaderService()